import { render, staticRenderFns } from "./EditMenuElement.vue?vue&type=template&id=b172174e&"
import script from "./EditMenuElement.vue?vue&type=script&lang=js&"
export * from "./EditMenuElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports